module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.1de7f049.eot";